module.exports = __webpack_public_path__ + "static/img/crispr_logo.2a72e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crispr_logo.png
// module id = kVmD
// module chunks = 15